import { SET_ALERT, REMOVE_ALERT } from './Types';
import { v4 as uuid } from 'uuid';

export const normalizeAlertMessage = (msg) => {
  if (msg instanceof Error) {
    return msg.message;
  }

  if (typeof msg === 'string') {
    return msg;
  }

  if (msg && typeof msg.message === 'string') {
    return msg.message;
  }

  if (msg && typeof msg.msg === 'string') {
    return msg.msg;
  }

  return String(msg ?? '');
};

export const setAlert = (msg, alertType) => (dispatch) => {
  const id = uuid();
  dispatch({
    type: SET_ALERT,
    payload: { msg: normalizeAlertMessage(msg), alertType, id },
  });

  setTimeout(() => dispatch({ type: REMOVE_ALERT, payload: id }), 3000);
};
